import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  ScrollView,
} from '../utils/webComponents';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from '../hooks/useTranslation';

const AboutScreen = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={[styles.scrollContent, { alignItems: 'center' }]}
      >
        <View style={styles.content}>
          <Text style={[styles.title, { color: theme.text }]}>
            {t('about.title')}
          </Text>

          <Text style={[styles.tagline, { color: theme.textSecondary }]}>
            {t('about.tagline')}
          </Text>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('about.description')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.descriptionText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('about.keyFeatures')}
            </Text>

            <Text style={[styles.featureTitle, { color: theme.text }]}>
              {t('about.aiPowered')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.aiPoweredDescription').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.featureTitle, { color: theme.text }]}>
              {t('about.spacedRepetition')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.spacedRepetitionDescription').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.featureTitle, { color: theme.text }]}>
              {t('about.cloudSync')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.cloudSyncDescription').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.featureTitle, { color: theme.text }]}>
              {t('about.referralSystem')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.referralSystemDescription').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('about.mission')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.missionText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('about.technology')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('about.technologyText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.footer, { color: theme.textSecondary }]}>
              {t('about.copyright')}
            </Text>
            <Text style={[styles.footer, { color: theme.textSecondary }]}>
              {t('about.allRightsReserved')}
            </Text>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  content: {
    maxWidth: 700,
    width: 'calc(100% - 48px)',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 40,
  },
  title: {
    fontSize: 32,
    fontWeight: '700',
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  tagline: {
    fontSize: 18,
    marginBottom: 40,
    textAlign: 'center',
    display: 'block',
  },
  section: {
    marginBottom: 32,
  },
  sectionTitle: {
    fontSize: 22,
    fontWeight: '600',
    marginBottom: 12,
    textAlign: 'center',
    display: 'block',
  },
  featureTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginTop: 24,
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  paragraph: {
    fontSize: 16,
    lineHeight: '1.6',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
  },
  footer: {
    fontSize: 14,
    marginTop: 16,
    textAlign: 'center',
    display: 'block',
  },
});

export default AboutScreen;
